export const standards = [
  { id: "20GP", display: "20GP" },
  { id: "40GP", display: "40GP" },
  { id: "43GP", display: "43GP" },
  { id: "45GP", display: "45GP" },
  { id: "20RE", display: "20RE" },
  { id: "40RE", display: "40RE" },
  { id: "20RF", display: "20RF" },
  { id: "40RF", display: "40RF" },
  { id: "20TK", display: "20TK" },
  { id: "40TK", display: "40TK" },
  { id: "20OT", display: "20OT" },
  { id: "40OT", display: "40OT" },
  { id: "20FR", display: "20FR" },
  { id: "40FR", display: "40FR" },
];

export const chassis = [
  { id: "combineChassis", display: "콤바인 샤시" },
  { id: "combiLineChassis", display: "콤비라인 샤시" },
  { id: "lineChassis", display: "라인 샤시" },
  { id: "Axle3Chassis", display: "3축 샤시" },
  { id: "Axle2Chassis", display: "2축 샤시" },
  { id: "singleChassis", display: "싱글(미니) 샤시" },
];

export const vehicleType = [
  { id: "냉동탑", display: "냉동탑" },
  { id: "냉장탑", display: "냉장탑" },
  { id: "다마스", display: "다마스" },
  { id: "플러스", display: "플러스" },
  { id: "카고크레인", display: "카고크레인" },
  { id: "플러스축", display: "플러스축" },
  { id: "윙축", display: "윙축" },
  { id: "리프트", display: "리프트" },
  { id: "카캐리어", display: "카캐리어" },
  { id: "밴", display: "밴" },
  { id: "라보", display: "라보" },
  { id: "탱크로리", display: "탱크로리" },
  { id: "컨테이너", display: "컨테이너" },
  { id: "로베드", display: "로베드" },
  { id: "트레일러", display: "트레일러" },
  { id: "풀카", display: "풀카" },
  { id: "플러스윙", display: "플러스윙" },
  { id: "트랙터", display: "트랙터" },
];
